module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "change-email"
  }, [(_vm.state == 'done') ? _c('div', {
    staticClass: "mdl-card mdl-shadow--2dp"
  }, [_c('div', {
    staticClass: "mdl-card__title mdl-color--primary"
  }, [_c('h2', {
    staticClass: "mdl-card__title-text"
  }, [_vm._v(_vm._s(_vm.i18n().done.title))])]), _vm._v(" "), _c('div', {
    staticClass: "mdl-card__supporting-text mdl-card--expand"
  }, [_vm._v("\n      " + _vm._s(_vm.i18n().done.text({
    email: _vm.newEmail
  })) + "\n    ")])]) : _vm._e(), _vm._v(" "), (_vm.state != 'done') ? _c('form', {
    staticClass: "mdl-card mdl-shadow--2dp",
    on: {
      "submit": _vm.change
    }
  }, [_c('div', {
    staticClass: "mdl-card__title mdl-color--primary"
  }, [_c('h2', {
    staticClass: "mdl-card__title-text"
  }, [_vm._v(_vm._s(_vm.i18n().title))])]), _vm._v(" "), _c('div', {
    staticClass: "mdl-card__supporting-text mdl-card--expand"
  }, [_c('div', {
    class: {
      blurred: _vm.state == 'working'
    }
  }, [(_vm.error) ? _c('div', {
    staticClass: "serverError"
  }, [_vm._v(_vm._s(_vm.i18n().errors[_vm.error] || _vm.error))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "mdl-textfield mdl-js-textfield mdl-textfield--floating-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newEmail),
      expression: "newEmail"
    }],
    ref: "newEmail",
    staticClass: "mdl-textfield__input",
    attrs: {
      "type": "email",
      "id": "newEmail",
      "required": _vm.required
    },
    domProps: {
      "value": (_vm.newEmail)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newEmail = $event.target.value
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "mdl-textfield__label",
    attrs: {
      "for": "newEmail"
    }
  }, [_vm._v(_vm._s(_vm.i18n().newEmail))])]), _vm._v(" "), _c('div', {
    staticClass: "mdl-textfield mdl-js-textfield mdl-textfield--floating-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentPassword),
      expression: "currentPassword"
    }],
    ref: "currentPassword",
    staticClass: "mdl-textfield__input",
    attrs: {
      "type": "password",
      "id": "currentPassword",
      "required": _vm.required
    },
    domProps: {
      "value": (_vm.currentPassword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.currentPassword = $event.target.value
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "mdl-textfield__label",
    attrs: {
      "for": "currentPassword"
    }
  }, [_vm._v(_vm._s(_vm.i18n().currentPassword))])])]), _vm._v(" "), (_vm.state == 'working') ? _c('div', {
    staticClass: "working"
  }, [_c('div', {
    staticClass: "mdl-spinner mdl-js-spinner is-active"
  })]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "mdl-card__actions mdl-card--border",
    class: {
      blurred: _vm.state == 'working'
    }
  }, [_c('button', {
    staticClass: "mdl-button mdl-button--colored mdl-js-button mdl-js-ripple-effect",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("\n        " + _vm._s(_vm.i18n().submit) + "\n      ")])])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fbae35a8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/emailPassword/ChangeEmail.vue
// module id = 475
// module chunks = 0